const initialState = {
    notifications: [],
    totalNotifications: 0,
    unreadCount: 0,
    readCount: 0,
    pagination: {}
};

const headerReducer = (state = initialState, action) => {
    switch (action.type) {
        case "FETCH_NOTIFICATIONS":
            console.log('FETCH_NOTIFICATIONS action payload:', action.payload);
            const { data } = action.payload;
            const notificationsData = data?.data || [];
            const counts = data?.counts || {};
            const pagination = data?.pagination || {};
            console.log('Processed notifications data:', {
                notificationsData,
                counts,
                pagination
            });
            return {
                ...state,
                notifications: notificationsData,
                totalNotifications: counts.total || 0,
                unreadCount: counts.unread || 0,
                readCount: counts.read || 0,
                pagination: pagination
            };

        case "MARK_NOTIFICATION_READ":
            return {
                ...state,
                notifications: state.notifications.map(notification =>
                    notification._id === action.payload
                        ? { ...notification, status: 'READ' }
                        : notification
                ),
                unreadCount: Math.max(0, state.unreadCount - 1),
                readCount: state.readCount + 1
            };

        case "MARK_ALL_NOTIFICATIONS_READ":
            return {
                ...state,
                notifications: state.notifications.map(notification => ({
                    ...notification,
                    status: 'READ'
                })),
                unreadCount: 0,
                readCount: state.totalNotifications
            };

        case "LOGOUT":
            return initialState;

        default:
            return state;
    }
};

export default headerReducer;
